import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { Calendar as DatePicker } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';

const EventDialog = ({
    visible,
    event,
    setEvent,
    onHide,
    onSave,
    onDelete,
    eventColors,
    todos,
    repeatOptions
}) => {
    const dialogFooter = (
        <>
            {event.id && (
                <Button 
                    label="Delete" 
                    icon="pi pi-trash" 
                    className="p-button-danger" 
                    onClick={() => {
                        onHide();
                        onDelete();
                    }} 
                />
            )}
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label={event.id ? 'Update' : 'Create'} icon="pi pi-check" onClick={onSave} />
        </>
    );

    return (
        <Dialog
            visible={visible}
            header={event.id ? 'Edit Event' : 'Create New Event'}
            modal
            className="create-event-dialog-custom frazza-dialog-lg"
            footer={dialogFooter}
            onHide={onHide}
        >
            <div className="frazza-form-group full-width">
                <label htmlFor="title" className="frazza-form-label required">Event Title</label>
                <InputText
                    id="title"
                    value={event.title}
                    onChange={(e) => setEvent({...event, title: e.target.value})}
                    required
                    autoFocus
                    placeholder="What's happening?"
                    className="frazza-input"
                />
            </div>

            <div className="frazza-form-group">
                <label htmlFor="start" className="frazza-form-label">Start</label>
                <DatePicker
                    id="start"
                    value={event.start}
                    onChange={(e) => setEvent({...event, start: e.value})}
                    showTime={!event.allDay}
                    dateFormat="dd/mm/yy"
                    hourFormat="12"
                    stepMinute={15}
                    className="frazza-input"
                />
            </div>

            <div className="frazza-form-group">
                <label htmlFor="end" className="frazza-form-label">End</label>
                <DatePicker
                    id="end"
                    value={event.end}
                    onChange={(e) => setEvent({...event, end: e.value})}
                    showTime={!event.allDay}
                    dateFormat="dd/mm/yy"
                    hourFormat="12"
                    stepMinute={15}
                    className="frazza-input"
                />
            </div>

            <div className="frazza-checkbox-item full-width">
                <Checkbox
                    inputId="allDay"
                    checked={event.allDay}
                    onChange={(e) => setEvent({...event, allDay: e.checked})}
                    className="frazza-checkbox"
                />
                <label htmlFor="allDay" className="frazza-checkbox-label">All Day Event</label>
            </div>

            <div className="frazza-form-group">
                <label htmlFor="color" className="frazza-form-label">Color</label>
                <Dropdown
                    id="color"
                    value={event.backgroundColor}
                    options={eventColors}
                    onChange={(e) => setEvent({...event, backgroundColor: e.value})}
                    optionLabel="name"
                    optionValue="value"
                    placeholder="Select color"
                    className="frazza-select"
                />
            </div>

            <div className="frazza-form-group">
                <label htmlFor="linkedTodo" className="frazza-form-label">Link to Task</label>
                <Dropdown
                    id="linkedTodo"
                    value={event.linkedTodoId}
                    options={todos.map(todo => ({
                        label: todo.todo || todo.title || "Untitled Task",
                        value: todo.id
                    }))}
                    onChange={(e) => setEvent({...event, linkedTodoId: e.value})}
                    placeholder="Select a task (optional)"
                    optionLabel="label"
                    className="frazza-select"
                    showClear
                />
            </div>

            <div className="frazza-form-group full-width">
                <label htmlFor="description" className="frazza-form-label">Description</label>
                <InputTextarea
                    id="description"
                    value={event.description}
                    onChange={(e) => setEvent({...event, description: e.target.value})}
                    rows={3}
                    className="frazza-textarea"
                    placeholder="Add details about your event..."
                />
            </div>

            <div className="frazza-checkbox-item full-width">
                <Checkbox
                    inputId="repeat"
                    checked={event.repeat}
                    onChange={(e) => setEvent({...event, repeat: e.checked})}
                    className="frazza-checkbox"
                />
                <label htmlFor="repeat" className="frazza-checkbox-label">Repeat this event</label>
            </div>

            {event.repeat && (
                <div className="repeat-section full-width">
                    <div className="frazza-form-row two-col">
                        <div className="frazza-form-group">
                            <label htmlFor="repeatType" className="frazza-form-label">Frequency</label>
                            <Dropdown
                                id="repeatType"
                                value={event.repeatType}
                                options={repeatOptions}
                                onChange={(e) => setEvent({...event, repeatType: e.value})}
                                optionLabel="name"
                                className="frazza-select"
                            />
                        </div>
                        <div className="frazza-form-group">
                            <label htmlFor="repeatUntil" className="frazza-form-label">Until</label>
                            <DatePicker
                                id="repeatUntil"
                                value={event.repeatUntil}
                                onChange={(e) => setEvent({...event, repeatUntil: e.value})}
                                dateFormat="dd/mm/yy"
                                className="frazza-input"
                                minDate={event.start}
                            />
                        </div>
                    </div>
                </div>
            )}
        </Dialog>
    );
};

export default EventDialog;